import React, { ReactElement, useState } from 'react';
import { MultiSelect } from 'slovlex-idsk-react-components';
import PublikovanyTerminFilter from '../../../model/PublikovanyTerminFilter';
import { SafeParameterSetter } from '../../../model/SafeParameterSetter';
import useSearchPouzitiePredpisList from '../../../hooks/useSearchPouzitiePredpisList';
import PouzitiePredpis from '../../../model/PouzitiePredpis';
import {
  MAX_MULTISELECT_RESULT,
  SHOW_ALL_MAX_RESULT,
} from '../../../constants/MultiSelectConstant';

interface Props {
  data: PublikovanyTerminFilter;
  onUpdateField: SafeParameterSetter<PublikovanyTerminFilter>;
}

const PouzitiePredpisMultiSelect = (({
  data, onUpdateField,
}: Props): ReactElement => {
  const [searchText, setSearchText] = useState('');
  const [limit, setLimit] = useState(MAX_MULTISELECT_RESULT);

  const {
    pouzitiePredpisList,
    pouzitiePredpisListStatus,
  } = useSearchPouzitiePredpisList(searchText, limit);

  return (
    <div className="slovlex-idsk-side-panel-input-wrapper">
      <MultiSelect
        handleShowAll={() => {
          setLimit(SHOW_ALL_MAX_RESULT);
        }}
        withShowAllButton={(limit === MAX_MULTISELECT_RESULT
            && pouzitiePredpisList.length === MAX_MULTISELECT_RESULT)
          || (limit === SHOW_ALL_MAX_RESULT && pouzitiePredpisList.length <= MAX_MULTISELECT_RESULT)}
        searchText={searchText}
        setSearchText={(text) => {
          setSearchText(text);
          setLimit(MAX_MULTISELECT_RESULT);
        }}
        loading={pouzitiePredpisListStatus.loading}
        width="full"
        label="Použité v právnom predpise"
        itemListAttribute="popis"
        dataAttributesToShow={[{ key: 'popis', label: '' }]}
        data={pouzitiePredpisList}
        selectedItemList={data.pouzitiePredpisList}
        setSelectedItemList={(itemList: PouzitiePredpis[]) => {
          onUpdateField('pouzitiePredpisList', itemList);
        }}
        visibilityMinSearchLength={0}
        fazet
        showItemList={false}
      />
    </div>
  );
});

export default PouzitiePredpisMultiSelect;
